import React from "react";
import "./FAQSection.css";

const FAQSection = () => {
  const faqData = [
    {
      title: "Insane Customer Focus",
      description:
        "Yes! We prioritize security with advanced encryption, strict compliance policies, and transparent processes to protect your funds at every step.",
    },
    {
      title: "Lean & Disciplined",
      description:
        "We do more with less. Constraint drives us to innovate through scalable technology–not excess resources. We set ambitious goals, benchmark performance, and weigh trade offs before changing course",
    },
    {
      title: "Is my money safe with Grow Bizint International?",
      description:
        "Yes! We prioritize security with advanced encryption, strict compliance policies, and transparent processes to protect your funds at every step.",
    },
    {
      title: "What is the minimum investment amount?",
      description:
        "You can start investing with as little as you like, making it easy for anyone to begin their financial growth journey.",
    },
    {
      title: "How and when can I withdraw my profits?",
      description:
        "Profits are credited monthly and you can withdraw them easily at the end of each month through your preferred payment method.",
    },
    {
      title: "Does Grow Bizint International charge any hidden fees?",
      description:
        "No. Grow Bizint International is fully transparent—there are no hidden charges or surprise deductions.",
    },
  ];

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-heading">Frequently Asked Questions</h2>

        <div className="faq-grid">
          {faqData.map((item, index) => (
            <div key={index} className="faq-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
